import React from 'react';
import styles from '../MessengerMessage.module.scss';
const Comment = ({ feedComment }) => {
    return (React.createElement("div", { className: styles.messageContainer },
        React.createElement("div", null, feedComment.message)));
};
export default Comment;
